module.exports = __webpack_public_path__ + "img/dpCommerceIntro.bbdbe613.png";